<template>
  <div class="poll__add">
    <h1>{{ $t("module.poll") }}</h1>
    <b-field :label="$t('module.points')">
      <b-numberinput controls-rounded v-model="points"></b-numberinput>
    </b-field>
    <div class="questions">
      <h2>{{ $t("module.questions") }}</h2>
      <div class="list" v-if="questions.length > 0">
        <ul>
          <li
            v-for="question in questions"
            :key="question.id"
            :class="
              questionIndex !== null &&
              questions[questionIndex] &&
              question.id == questions[questionIndex].id
                ? 'selected'
                : ''
            "
            @click="selectQuestion(question)"
          >
            <div>
              <span>{{ question.text }}</span>
              <b-button
                @click="removeQuestion(question)"
                class="button is-danger round"
                icon-left="delete"
              >
              </b-button>
            </div>
          </li>
        </ul>
      </div>
      <b-field>
        <b-input
          v-model="question.text"
          :placeholder="`${$t('module.newQuestion')}`"
          name="question"
          v-validate="'required'"
        />
      </b-field>

      <b-button
        @click="addQuestion"
        :disabled="question.text.length === 0"
        class="button is-info is-rounded action-button"
        icon-left="plus"
      >
        {{ $t("module.question") }}
      </b-button>
    </div>
    <div
      class="answers"
      v-if="questionIndex != null && questions[questionIndex]"
    >
      <span>{{
        `${$t("module.selectedQuestion")}: ${questions[questionIndex].text}`
      }}</span>
      <h2>{{ $t("module.answers") }}</h2>
      <div
        v-if="
          questions[questionIndex] &&
            questions[questionIndex].answers.length > 0
        "
      >
        <div class="list">
          <ul>
            <li
              v-for="answer in questions[questionIndex].answers"
              :class="answer.isCorrect ? 'isCorrect' : ''"
              :key="answer.id"
            >
              <div>
                <span>{{ answer.text }}</span>
                <b-button
                  @click="removeAnswer(answer)"
                  class="button is-danger round"
                  icon-left="delete"
                >
                </b-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <b-field>
          <b-input
            v-model="answer.text"
            :placeholder="`${$t('module.newAnswer')}`"
            name="answer"
            v-validate="'required'"
          />
        </b-field>
      </div>
      <b-button
        @click="addAnswer"
        :disabled="answer.text.length === 0"
        class="button is-info is-rounded action-button add"
        icon-left="plus"
      >
        {{ $t("module.answer") }}
      </b-button>
    </div>
    <b-button
      :disabled="questions.length == 0"
      @click="savePoll"
      class="button is-success is-rounded action-button save-quiz"
      :title="$t('module.save')"
    >
      {{ $t("module.save") }}
    </b-button>
  </div>
</template>

<script>
import { generateId } from "../../utils/helpers";
import { mapGetters } from "vuex";

export default {
  name: "add",
  props: {
    quiz: {
      type: Object
    }
  },
  data: () => {
    return {
      selectedQuestion: null,
      questionIndex: null,
      points: 0,
      question: {
        id: generateId(),
        text: "",
        answers: [],
        type: 0
      },
      answer: {
        id: generateId(),
        text: "",
        isCorrect: false
      },
      questions: []
    };
  },
  computed: {
    ...mapGetters(["user", "tenant"])
  },
  methods: {
    addAnswer() {
      this.questions[this.questionIndex].answers.push(this.answer);

      this.answer = {
        id: generateId(),
        text: "",
        isCorrect: false
      };
    },
    removeAnswer(answer) {
      this.questions[this.questionIndex].answers = this.questions[
        this.questionIndex
      ].answers.filter(item => {
        return item.id !== answer.id;
      });
    },
    addQuestion() {
      this.questions.push(this.question);
      this.questionIndex = this.questions.indexOf(this.question);

      this.question = {
        id: generateId(),
        text: "",
        answers: [],
        type: 0
      };
    },
    savePoll() {
      this.$emit("save", {
        id: generateId(),
        points: this.points,
        questions: this.questions
      });
    },
    removeQuestion(question) {
      this.questions = this.questions.filter(item => {
        return item.id !== question.id;
      });
      this.questionIndex = null;
    },
    selectQuestion(question) {
      this.questionIndex = this.questions.indexOf(question);
    }
  },
  created() {
    if (this.quiz) {
      this.questions = this.quiz.questions;
    }
  }
};
</script>

<style></style>
